<template>
    <main class="container_istc_desktop" id="ISCTDesktop">
        <!--  section left-->
        <secction class="container_istc_desktop__section_left">
            <article class="container_istc_desktop__section_left__article">
                <!-- aside top -->
                <aside class="container_istc_desktop__section_left__article__aside_top">
                    <div class="container_istc_desktop__section_left__article__aside_top__div">
                        <img src="@/assets/rifle_tactical_reload.jpg" alt="Instruction au tir de combat"
                            class="container_istc_desktop__section_left__article__aside_top__div__img">
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_istc_desktop__section_left__article__aside_bottom">
                    <div class="container_istc_desktop__section_left__article__aside_bottom__div_text">
                        <p class="container_istc_desktop__section_left__article__aside_bottom__div_text__p">
                            Formation instruction au tir de combat.
                            Positions de tir fondamentaux etc.

                            Instruction au domaine tactique.
                        </p>
                    </div>
                    <div class="container_istc_desktop__section_left__article__aside_bottom__div_link">
                        <a href="https://fr.wikipedia.org/wiki/wordpress"
                            class="container_istc_desktop__section_left__article__aside_bottom__div_link__a">
                            <p class="container_istc_desktop__section_left__article__aside_bottom__div_link__a__p">
                                wikipédia
                            </p>
                        </a>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section middle -->
        <!-- ############## -->
        <secction class="container_istc_desktop__section_middle">
            <!-- article top -->
            <article class="container_istc_desktop__section_middle__article_top">
                <aside class="container_istc_desktop__section_middle__article_top__aside">
                    <!-- div vide -->
                    <div class="container_istc_desktop__section_middle__article_top__aside__div_vide_1">

                    </div>

                    <!-- div titre -->
                    <div class="container_istc_desktop__section_middle__article_top__aside__div_titre">
                        <h1 class="container_istc_desktop__section_middle__article_top__aside__div_titre__h1">
                            Manipulations
                        </h1>
                    </div>

                    <!-- div vide -->
                    <div class="container_istc_desktop__section_middle__article_top__aside__div_vide_2">

                    </div>

                </aside>
            </article>
            <!-- ############## -->
            <!-- Article middle -->
            <!-- ############## -->
            <article class="container_istc_desktop__section_middle__article_middle w3-container">
                <aside id="id01" class="container_istc_desktop__section_middle__article_middle__aside w3-modal ">
                    <!-- div options -->
                    <div
                        class="w3-modal-content container_istc_desktop__section_middle__article_middle__aside__div_option">
                        <div
                            class="w3-container container_istc_desktop__section_middle__article_middle__aside__div_option__div">
                            <span onclick="document.getElementById('id01').style.display='none'"
                                class="w3-button w3-display-topright container_istc_desktop__section_middle__article_middle__aside__div_option__div__span">&times;</span>
                            <h1
                                class="container_istc_desktop__section_middle__article_middle__aside__div_option__div__h1">
                                Options
                            </h1>
                            <p
                                class="container_istc_desktop__section_middle__article_middle__aside__div_option__div__p">
                                - 300€ maquette sans animation ( adobe XD )<br />
                                - 600€ maquette avec animations ( 2 modifications gratuites )<br />
                                - 200€ la modifications et 100€ par jours de retard ( du client au sujet de la
                                modifications maquette )<br />
                                - 200€ l'hébergement web<br />
                                - 2 000€ déplacement ( en France )( voir CGV pour plus d'information )<br />
                                - Maintenance 280€ l'ajout<br />
                                - Devis 100€<br />
                            </p>
                        </div>
                    </div>
                </aside>
            </article>
            <!-- ############## -->
            <!-- Article bottom -->
            <!-- ############## -->
            <article class="container_istc_desktop__section_middle__article_bottom">
                <!-- précédent -->
                <aside class="container_istc_desktop__section_middle__article_bottom__aside_back">
                    <div class="container_istc_desktop__section_middle__article_bottom__aside_back__div">
                        <button class="container_istc_desktop__section_middle__article_bottom__aside_back__div__button">
                            <router-link
                                class="container_istc_desktop__section_middle__article_bottom__aside_back__div__button__router-link"
                                to="/defense">
                                <div
                                    class="container_istc_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_istc_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
                <!-- suivant -->
                <aside class="container_istc_desktop__section_middle__article_bottom__aside_next">
                    <div class="container_istc_desktop__section_middle__article_bottom__aside_next__div">
                        <button class="container_istc_desktop__section_middle__article_bottom__aside_next__div__button">
                            <router-link
                                class="container_istc_desktop__section_middle__article_bottom__aside_next__div__button__router-link"
                                to="/instruction">
                                <div
                                    class="container_istc_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_istc_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section right -->
        <!-- ############## -->
        <secction class="container_istc_desktop__section_right">
            <article class="container_istc_desktop__section_right__article">
                <aside class="container_istc_desktop__section_right__article__aside_top">
                    <div class="container_istc_desktop__section_right__article__aside_top__div">
                        <h1 class="container_istc_desktop__section_right__article__aside_top__div__h1">
                            Tarifs
                        </h1>
                    </div>
                </aside>
                <!--  -->
                <aside class="container_istc_desktop__section_right__article__aside_middle">
                    <!-- div text -->
                    <div class="container_istc_desktop__section_right__article__aside_middle__div_text">
                        <p class="container_istc_desktop__section_right__article__aside_middle__div_text__p_top">
                            - Instruction ISTC = 140 € / jour <br>
                        </p>
                        <!-- prix -->
                        <p class="container_istc_desktop__section_right__article__aside_middle__div_text__p_bottom">
                            <!-- Prix total : 1 700 € -->
                        </p>
                    </div>
                </aside>
                <!-- aside bottom button -->
                <aside class="container_istc_desktop__section_right__article__aside_bottom">
                    <div class="container_istc_desktop__section_right__article__aside_bottom__div_left">
                        <router-link
                            class="container_istc_desktop__section_right__article__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_istc_desktop__section_right__article__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div class="container_istc_desktop__section_right__article__aside_bottom__div_right">
                        <button onclick="document.getElementById('id01').style.display='block'"
                            class="container_istc_desktop__section_right__article__aside_bottom__div_right__button">
                            <div
                                class="container_istc_desktop__section_right__article__aside_bottom__div_right__button__div_1">

                            </div>
                            <!--  -->
                            <div
                                class="container_istc_desktop__section_right__article__aside_bottom__div_right__button__div_2">

                            </div>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
    </main>
</template>

<script >
export default {
    name: 'IstcDesktop',
}
</script>

<style  lang=scss>
//@import "@/style/components/Services/ISTC/IstcDesktop.scss";

router-link {
    display: block;
}


#ISCTDesktop {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

@import "@/style/color.scss";

.container_istc_desktop {
    margin: auto;

    &__section_left {
        margin-top: auto;
        margin-bottom: auto;

        &__article {
            display: flex;
            flex-direction: column;
            margin-bottom: 20rem;

            &__aside_top {
                width: 35rem;

                &__div {
                    margin-top: 2rem;
                    margin-left: 2rem;

                    &__img {
                        width: 30rem;
                    }
                }
            }

            //bottom

            &__aside_bottom {
                width: 32rem;
                margin-top: 2rem;
                display: flex;
                flex-direction: row;

                &__div_text {
                    text-align: start;
                    margin-left: 2rem;

                    &__p {
                        font-size: 1.25rem;
                    }
                }

                //lien

                &__div_link {
                    text-align: center;
                    position: relative;
                    top: 8rem;
                    right: 7rem;

                    &__a {

                        &__p {
                            font-size: 1.25rem;
                            color: inherit;
                        }
                    }

                    // hover 

                    &__a:hover {
                        color: $RV;
                    }
                }
            }
        }
    }

    //###################
    // middle 
    //###################

    &__section_middle {
        margin-left: auto;
        margin-right: auto;

        &__article_top {
            margin-left: auto;
            margin-right: auto;

            &__aside {
                //position: absolute;
                margin-left: auto;
                margin-right: auto;
                //position: relative;
                //right: 4rem;
                display: flex;
                flex-direction: row;

                &__div_vide_1 {
                    background-color: $BF;
                    height: 65px;
                    width: 65px;
                    z-index: 1;
                    position: relative;
                    left: 4.2rem;
                    top: 0.1rem;
                }

                //

                &__div_titre {
                    background-color: white;
                    text-align: center;
                    display: block;
                    z-index: 2;
                    width: 12rem;

                    &__h1 {
                        font-size: 2rem;
                        color: inherit;
                    }
                }

                //

                &__div_vide_2 {
                    background-color: $RV;
                    height: 65px;
                    width: 65px;
                    z-index: 1;
                    position: relative;
                    right: 4.2rem;
                    bottom: 0.1rem;
                }
            }
        }

        // article middle

        &__article_middle {
            margin-right: auto;
            margin-left: auto;
            //height: 30vh;

            &__aside {
                /* From https://css.glass */
                background: rgba(255, 255, 255, 0.15);
                border-radius: 16px;
                box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
                backdrop-filter: blur(6.1px);
                -webkit-backdrop-filter: blur(6.1px);
                border: 1px solid rgba(255, 255, 255, 0.68);

                &__div_option {
                    border-radius: 1rem;
                    border: solid 0.125rem $BG;

                    &__div {
                        text-align: start;

                        &__h1 {
                            margin-right: auto;
                            margin-left: auto;
                            width: 8rem;
                        }

                        &__p {
                            padding-bottom: 2rem;
                        }
                    }
                }
            }
        }

        // article bottom

        &__article_bottom {
            margin-right: auto;
            margin-left: auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 38rem;
            padding-bottom: 1rem;

            &__aside_back {
                -webkit-box-shadow: -4px -4px 16px 6px rgba(0, 0, 0, 0.16);
                box-shadow: -4px -4px 16px 6px rgba(0, 0, 0, 0.16);

                height: 6rem;
                width: 6rem;
                border-radius: 1rem;

                &__div {
                    margin: auto;
                    height: 6rem;
                    width: 6rem;

                    &__button {
                        margin: auto;
                        height: 6rem;
                        width: 6rem;
                        border: none;
                        background-color: white;
                        border-radius: 1rem;

                        &__router-link {
                            margin: auto;
                            display: flex;
                            flex-direction: column;

                            &__div_1 {
                                margin: auto;
                                position: relative;
                                bottom: 1.06rem;
                                right: 0.5rem;
                                height: 0.25rem;
                                width: 3.5rem;
                                background-color: $BF;
                                rotate: z -45deg;
                            }

                            //

                            &__div_2 {
                                margin: auto;
                                position: relative;
                                top: 1.06rem;
                                right: 0.5rem;
                                height: 0.25rem;
                                width: 3.5rem;
                                background-color: $BF;
                                rotate: z 45deg;
                            }
                        }
                    }
                }
            }

            // suivant

            &__aside_next {
                -webkit-box-shadow: -4px -4px 16px 6px rgba(0, 0, 0, 0.16);
                box-shadow: -4px -4px 16px 6px rgba(0, 0, 0, 0.16);

                height: 6rem;
                width: 6rem;
                border-radius: 1rem;

                &__div {
                    margin: auto;
                    height: 6rem;
                    width: 6rem;

                    &__button {
                        margin: auto;
                        height: 6rem;
                        width: 6rem;
                        border: none;
                        background-color: white;
                        border-radius: 1rem;

                        &__router-link {
                            margin: auto;
                            display: flex;
                            flex-direction: column;

                            &__div_1 {
                                margin: auto;
                                position: relative;
                                bottom: 1.06rem;
                                left: 0.5rem;
                                height: 0.25rem;
                                width: 3.5rem;
                                background-color: $BF;
                                rotate: z 45deg;
                            }

                            //

                            &__div_2 {
                                margin: auto;
                                position: relative;
                                top: 1.06rem;
                                left: 0.5rem;
                                height: 0.25rem;
                                width: 3.5rem;
                                background-color: $BF;
                                rotate: z -45deg;
                            }
                        }
                    }
                }
            }
        }
    }

    //###################
    // right 
    //###################

    &__section_right {
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 2rem;

        &__article {
            margin-right: auto;
            margin-left: 2rem;
            margin-bottom: 20rem;
            display: flex;
            flex-direction: column;


            //top 

            &__aside_top {
                margin-right: auto;
                margin-left: auto;

                &__div {
                    text-align: center;
                    //border-bottom: solid 0.5rem $BF;

                    &__h1 {
                        font-size: 2rem;
                        font-weight: normal;
                        text-decoration: underline 0.125rem $BF;
                    }
                }
            }

            // aside middle

            &__aside_middle {
                background-color: $BG;
                margin-right: auto;
                margin-left: auto;
                width: 35rem;
                height: 20rem;
                border-radius: 2rem;

                &__div_text {
                    display: flex;
                    flex-direction: column;
                    align-self: flex-end;
                    width: 20rem;
                    position: relative;
                    left: 15rem;

                    &__p_top {
                        margin-top: 1rem;
                        font-size: 1.5rem;
                    }

                    &__p_bottom {
                        visibility: hidden;
                        margin-top: 2rem;
                        font-size: 1.5rem;
                    }
                }
            }

            //bottom

            &__aside_bottom {
                margin-right: auto;
                margin-left: auto;
                display: flex;
                flex-direction: row;
                position: relative;
                bottom: 6rem;

                &__div_left {
                    background-color: $N;
                    width: 12rem;
                    height: 4rem;
                    border-radius: 2rem;
                    margin-left: 8rem;


                    &__router-link {
                        margin: auto;
                        text-align: center;

                        &__p {
                            margin-top: 0.5rem;
                            margin-bottom: 1rem;
                            color: white;
                            font-size: 2rem;
                        }

                        // hover

                        &__p:hover {
                            color: $RV;
                        }
                    }
                }

                // right

                &__div_right {
                    margin-left: 2rem;
                    visibility: hidden;

                    &__button {
                        background-color: $N;
                        width: 4rem;
                        height: 4rem;
                        border-radius: 2rem;
                        border: none;
                        display: flex;
                        flex-direction: row;

                        &__div_1 {
                            width: 0.25rem;
                            height: 3.5rem;
                            background-color: white;
                            margin: auto;
                            border-radius: 0.5rem;
                            rotate: z 90deg;
                            z-index: 1;
                            position: relative;
                            left: 1rem;
                        }

                        //

                        &__div_2 {
                            width: 0.25rem;
                            height: 3.5rem;
                            background-color: white;
                            margin: auto;
                            border-radius: 0.5rem;
                            rotate: z 180deg;
                            z-index: 1;
                            position: relative;
                            right: 1rem;
                        }
                    }
                }
            }

        }
    }
}

@media screen and(max-width: 926px) {
    #ISCTDesktop {
        display: none;
    }
}
</style>